import PlausibleProvider from "next-plausible";
import { ReactNode, useEffect } from "react";

import { PUBLIC_URL } from "@/constants";
import useAnalytics from "@/hooks/useAnalytics";
import useGlobalState from "@/hooks/useGlobalState";

export * from "./gtm";

export type AnalyticsProps = {
  children: ReactNode;
};

export const Analytics = ({ children }: AnalyticsProps) => {
  const { hasAcceptedCookies } = useGlobalState();
  const { initializePixels } = useAnalytics();

  useEffect(() => {
    try {
      // Empty then block to satisfy linter since initialize is async ¯\_(ツ)_/¯
      initializePixels().then(() => {});
    } catch (error) {
      throw new Error(error);
    }
  }, [hasAcceptedCookies]);

  return (
    <PlausibleProvider
      domain={new URL(PUBLIC_URL).host}
      enabled
      trackLocalhost
      taggedEvents
      revenue
    >
      {children}
    </PlausibleProvider>
  );
};
